import React from "react";
import DefaultBlock from "./DefaultBlock";
import PlayerBlock from "./PlayerBlock";
import PlayerStateBlock from "./PlayerStateBlock";
import QuizBlock from "./QuizBlock";
import HallDescription from "./HallDescription";
import HallEpisodesBlock from "./HallEpisodesBlock";
import BannersBlock from "./BannersBlock";
import TextBlock from "./TextBlock";
import ButtonBlock from "./ButtonBlock";
import PosterBlock from "./PosterBlock";
import CountdownBlock from "./CountdownBlock";
import ActivityRatingBlock from "./ActivityRatingBlock";
import PartnersBlock from "./PartnersBlock";
import CoverBlock from "./CoverBlock";
import PrizeShopBlock from "./PrizeShopBlock";
import CustomWidgetBlock from "./CustomWidgetBlock";

export default {
    'default': DefaultBlock,
    'player': PlayerBlock,
    'playerState': PlayerStateBlock,
    'quizzes': QuizBlock,
    'hall-description': HallDescription,
    'hall-episodes': HallEpisodesBlock,
    'legacy-banners': BannersBlock,
    'text-block': TextBlock,
    'buttons': ButtonBlock,
    'poster': PosterBlock,
    'countdown': CountdownBlock,
    'activity-rating': ActivityRatingBlock,
    'partners': PartnersBlock,
    'cover': CoverBlock,
    'shop': PrizeShopBlock,
    'custom-widget': CustomWidgetBlock,
};
